<template>
    <div v-if="isShow" :style="domStyle">
        <!-- 请在此添加代码 -->
        <div class="fangshan" :style="{ left: 0,top:0}">
            <div class="shu" :style="{ background: shuColor}"></div>
            <div class="agitator">
                <img :src="src" alt="搅拌器" width="320" height="240" ref="img">
            </div>
        </div>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
import $ from 'jquery';
export default {
    name : "",
    props : ["primitives","fvSystemApi","parentObject"],
    created : function(){
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.width + "px",
            height : this.height + "px"
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        }
        this.shuColor=`-webkit-linear-gradient(left, ${this.backgroundColor}, #fff, ${this.backgroundColor})`
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
        
        this.resultRun();
        
    },
    mounted() {
        //产生随机字母 
        this.ranNum = this.getRanNum();
        //给domo节点添加class
        this.$el.children[0].className +=" "+this.ranNum;
        if(this.directionRotation=="up"){
            $("."+this.ranNum).css({"transform":"rotate(180deg)","transformOrigin":"center center"});
        }else if(this.directionRotation=="left"){
            $("."+this.ranNum).css({"transform":"rotate(90deg)","transformOrigin":"center center"});
        }else if(this.directionRotation=="right"){
            $("."+this.ranNum).css({"transform":"rotate(-90deg)","transformOrigin":"center center"});
        }else{
            $("."+this.ranNum).css({"transform":"rotate(360deg)","transformOrigin":"center center"});
        }
        this.isStop();
        
    },
    data : function(){
        return {
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            src:'require("./img/agitator.gif")',
            listNumb:false,
            ranNum:"",
            shuColor:"",
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {}
        }
    },
    methods : {
        isStop(){
            if(Number(this.listNumb)>=1){
                this.src=require("./img/agitator.gif");
            }else{
                this.src=require("./img/agitator.png");
            }
        },
        //生成随机数
        getRanNum(){
            var result = [];
                for(var i=0;i<4;i++){
                var ranNum = Math.ceil(Math.random() * 25); //生成一个0到25的数字
                    //大写字母'A'的ASCII是65,A~Z的ASCII码就是65 + 0~25;然后调用String.fromCharCode()传入ASCII值返回相应的字符并push进数组里
                    result.push(String.fromCharCode(65+ranNum));
                }
            return  result.join('');
        },
        /*
            参数：src 原json数据
            作用：混淆数据到当前对象
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){

        },
        /**
         * 判断是否为函数
         */
        isFunction(fn) {
            return Object.prototype.toString.call(fn)=== '[object Function]';
        },
        resultRun(){
            if(this.data.indexOf(".PV")!==-1){
                this.listNumb = this.fvSystemApi.getReal(this.data.split("$").join("")).PV;
            }else {
                if(__systemMidVar[this.data]==undefined){
                    if(this.isFunction(this.fvScript[this.data])){
                        this.listNumb = this.fvScript[this.data]();
                        if(!isNaN(this.listNumb)){
                            this.listNumb = this.listNumb;
                        }else{
                            this.listNumb = 1;
                        }
                    }else{
                        // this.$Notice.error({
                        //     title: "提示",
                        //     desc: "变量选取错误"
                        // });
                        this.listNumb=0;
                    }
                    
                }else{
                    this.listNumb =__systemMidVar[this.data].value;
                }
                
            }
        },
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            if(this.isEnable) return;
            this.resultRun();
            this.isStop();
        },
        /*
            参数：无
            作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
        */
        onClose(){
            return new Promise((resolve)=>{
                resolve();
            })
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            this.$el.style.fontSize = parseInt((12 * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px"; 
            this.domStyle.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.domStyle.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
            this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.domStyle.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px"; 
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show : function(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable : function(isEnable){
            this.isEnable = isEnable ? false : true;
        }
    }
}
</script>
<style scoped>
   .fangshan {
            margin: 0 auto;
            /* width: 200px;
            height: 400px; */
            overflow: hidden;
            /* margin-top: 15%; */
            /* line-height: 400px; */
            position: relative;
            margin: auto;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
        }
        .shu {
            width: 10%;
            height: 79%;
            box-shadow: 0px 0 5px 0px #dedede;
            /* background: -webkit-linear-gradient(left, rgb(157,150,138), #fff, rgb(157,150,138)); */
            /* background: -moz-linear-gradient(left,  rgb(157,150,138), #fff, rgb(157,150,138));
            background: -o-linear-gradient(left, rgb(157,150,138), #fff, rgb(157,150,138)); */
            /* background: #ccc; */
            /* box-shadow: 2px 0 2px 2px #dedede; */
            /* margin-left: 89px;
            position: relative; */
            z-index: 2000;
            /* border-bottom: 1px solid #000; */
            /* display: inline-block; */
            position: absolute;
            top: 0;
            left: 44%;
        }
        .agitator{
            position: absolute;
            top: 68%;
            left: 0;
            width: 100%;
            height: 30%;
        }
        .agitator img{
            width: 100%;
            height: 100%;
        }
</style>


// WEBPACK FOOTER //
// src/components/primitives/fvAgitator/fvAgitator.vue